module.exports = __webpack_public_path__ + "media/images/icons/quote-65761358015ccebca11a4b4d353af629.svg";